export default

    class TermoDeUsoController {

    constructor(resource) {
        this._resource = resource
    }

    async create(termoDeUso){
        return this._resource('termo-de-uso/aceitar')
            .save(termoDeUso)
            .then( res => res.body)
            .catch( error => { throw error})
    }

    async getByUserId(){
        return this._resource('termo-de-uso')
        .get()
        .then( res => res.body)
        .catch( error => { throw error})
    }

    
}